import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'

export default function AlertDialog(props) {
    const deleteData = (data) => {
        data.selectAll || data.select >= 2
            ? data.deleteAllDoctor()
            : data.deleteDoctor()
        data.setOpenDeleteBox(false)
    }
    return (
        <div>
            <Dialog
                open={props.data.openDeleteBox}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {`Are you sure you want to delete ${
                        props?.data?.doctorData?.name
                            ? `${props?.data?.doctorData?.name}'s`
                            : 'all users'
                    } data ?`}
                </DialogTitle>

                <DialogActions>
                    <Button onClick={() => props.data.setOpenDeleteBox(false)}>
                        No
                    </Button>
                    <Button onClick={() => deleteData(props.data)} autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
